module.exports = __webpack_public_path__ + "static/media/grandparent.51dede77.png";